import React from 'react';
import SyncLockIcon from '@mui/icons-material/SyncLock';
import {WebSocketOperationButton} from '../../components/web-socket/WebSocketOperationButton';
import {useCurrentOfficeStore} from '../../api/CurrentOfficeStore';
import {useOfficeStore} from '../../api/OfficeStore';
import {useRemoteValue} from '../../util/RemoteValue';

export default function SyncReleezmeButton() {
    const officeId = useCurrentOfficeStore(state => state.officeId);
    const offices = useRemoteValue(useOfficeStore(state => state.remoteValue), []);
    const enabled = offices.some(office => office.id === officeId && office.releezmeIntegrationEnabled);

    return enabled ? (
        <WebSocketOperationButton
            endpoint={`/api/operations/offices/${officeId}/sync-releezme`}
            variant="outlined"
            description="Synchronize current key holders and their transponder IDs with VECOS Releezme."
            actionButtonLabel="Sync VECOS"
            icon={<SyncLockIcon/>}
        />
    ) : null;
}
